import { render, staticRenderFns } from "./EstatisticasTarefasClientes.vue?vue&type=template&id=6201a9ee"
import script from "./EstatisticasTarefasClientes.vue?vue&type=script&lang=js"
export * from "./EstatisticasTarefasClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports